export default __webpack_public_path__ + "static/media/47t.b192ecfe.jpg";